import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { joiResolver } from '@hookform/resolvers/joi';

import { useAppContext } from '../../../app/Context';
import { getUserRegistration } from '../../../db/auth';
import { NextScreen } from '../../../db/auth/types';
import { useAuthContext } from '../Context';
import { AuthScreen } from '../types';
import { FormValues } from './types';
import { validationSchema } from './validators';
import routes from '../../../routes/router';

export enum VALIDATION_TYPES {
  EMAIL_NOT_FOUND = 'emailNotFound',
}

const useLoginEmailVM = () => {
  const { setSession, setSsoCredentials } = useAppContext();
  const { email, setEmail, setScreen } = useAuthContext();

  const formMethods = useForm<FormValues>({
    defaultValues: {
      emailId: '',
    },
    resolver: joiResolver(validationSchema),
    mode: 'onSubmit',
  });

  const { setError, getValues, setValue } = formMethods;

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    setEmail(data.emailId);
    const response = await getUserRegistration({ emailId: data.emailId });
    const { session, next } = response;
    if (session) {
      setSession(session);
    }
    switch (next) {
      case NextScreen.SSO:
        const { authUrl, sessionId } = response;
        setSsoCredentials({ authUrl, sessionId });
        setScreen(AuthScreen.SSO);
        break;
      case NextScreen.GET_PASSWORD:
        setScreen(AuthScreen.PASSWORD);
        break;
      default:
        /** not setting error message intentionally to render custom jsx on this error */
        setError('emailId', { type: VALIDATION_TYPES.EMAIL_NOT_FOUND }, { shouldFocus: true });
        break;
    }
  };

  const handleEmailBlur = () => {
    const { emailId } = getValues();
    setEmail(emailId);
  };

  useEffect(
    function setInitialValues() {
      setValue('emailId', email);
    },
    [email, setValue]
  );

  const acadlyHelpUrl = process.env.REACT_APP_ACADLY_HELP_URL ?? '';
  const acadlySignupUrl = `${process.env.REACT_APP_ACADLY_WEB_URL}${routes.DO_NOT_USE_ACADLY_SIGN_UP.acadlyWebUrl()}`;

  return {
    formMethods,
    onSubmit,
    handleEmailBlur,
    acadlyHelpUrl,
    acadlySignupUrl,
  };
};

export default useLoginEmailVM;
